'use client';
import { SunIcon, MoonIcon } from 'lucide-react';

import { useTheme } from '@/components/providers/ThemeProvider';

interface ThemeButtonProps {
  size?: number;
};

const ThemeButton = ({ size = 22 }: ThemeButtonProps) => {
  const { theme, toggleTheme } = useTheme();

  const isDarkMode = theme === 'chenook-dark';

  return (
    <label className='swap swap-rotate'>
      <input
        type='checkbox'
        className='theme-controller'
        checked={isDarkMode}
        onChange={toggleTheme}
      />
      <SunIcon size={size} className='swap-on' />
      <MoonIcon size={size} className='swap-off' />
    </label>
  );
};

export default ThemeButton;
